import { IForm } from 'core-components/classes/models/IForm'
import { sitePageInitialData } from 'core-components/sitebuilder/layout/helpers/sitePages'
import { ISitePage } from 'core-components/sitebuilder/models/ISitePage'
import { parseData } from 'src/core/classes/helpers'

export const createMap = (items: ISitePage[]): { [key: string]: ISitePage } => {
  const result: { [key: string]: ISitePage } = {}
  items.forEach((item) => (result[item.id] = item))
  return result
}

export const map = (data: IForm): ISitePage => {
  // TODO: remove parseData on new services
  const defaultSettingsParsed = parseData<IForm>(data['Settings'], 'object')
  const redirectUrlParsed =
    data['Layout'] === 'default' ? {} : parseData<IForm>(data['Layout'], 'object')
  const layoutSettings = parseData<IForm>(data['LayoutSettings'], 'object')

  return {
    ...sitePageInitialData,
    id: data['Id'],
    audience: data['AudienceFilter'],
    isNew: false,
    root: '',
    parent: data['ParentId'] || '',
    childrenIds: [],
    childrenVisibleIds: [],
    name: data['Title'] || '',
    type: data['NodeType'] || 'Static',
    iconClass: data['IconCssClass'] || '',
    order: data['Order'] || '0',
    layout: data['Layout'] || 'default',
    layoutUser: data['Layout'] || 'default',
    layoutSettings: layoutSettings,
    layoutUserSettings: layoutSettings,
    defaultSettings: defaultSettingsParsed,
    redirectOption: redirectUrlParsed.url ? 'Redirect to another site' : 'Inner redirect',
    redirectTo: data['RedirectTo'] || '',
    redirectWithParams: data['PreserveRedirectParams'] || false,
    redirectUrl: redirectUrlParsed.url || '',
    redirectWindow: redirectUrlParsed.windowInfo || '',
    url: '',
    hidden: +data['HiddenInMenu'],
    disabled: +data['Disabled'],
    visible: true,
    params: {} as IForm,
    roleIds: data['Roles'] || [],
    rolesMode: data['RolesMode'],
    groupName: data['GroupName'] || '',
    availableWidgetsData: data['Widgets'].map((w: any) => {
      return {
        area: w.Area,
        h: w.Height,
        i: w.Widget.Id,
        w: w.Width,
        x: w.X,
        y: w.Y,
        scale: w.scale,
      }
    }),
  }
}
